<div class="schedule-card-container mat-card">
  <div class="row">
    <div class="col-md-8 schedule-card-title" [title]="shiftData?.name">
      <span>{{shiftData.name | uppercase}}</span>
    </div>
    <div *ngIf="shiftData.name != 'Open To Close'" class=" col-md-3 schedule-card-action">
      <div (click)="deleteShift(shiftData.id)" class="mr" [title]="'scheduleRotation.deleteTheShift' | translate">
        <asp-icon color='rgba(14,19,25,0.8)' height='1rem' name="ic-20-utility-delete-trash.svg" width="1rem"></asp-icon>
      </div>
      <div (click)="updateShift(shiftData)" [title]="'scheduleRotation.updateTheShiftDetails' | translate">
        <asp-icon color='rgba(14,19,25,0.8)' height='1rem' name="ic-20-utility-edit.svg" width="1rem"></asp-icon>
      </div>
    </div>
  </div>
  <div class="schedule-card-body">
    <div *ngIf="shiftData.name === 'Open To Close'">Operational hours</div>
    <div *ngIf="shiftData.name != 'Open To Close'">{{fromTime | date:'shortTime' }} - {{toTime | date:'shortTime' }}</div>
  </div>


</div>
